module.exports = __webpack_public_path__ + "static/media/versace-bright-crystal-big.048af5f5.png";